import {
    GET_ASSET_PROPERTY_DEFINITIONS_OPERATION,
    CREATE_ASSET_PROPERTY_DEFINITION_OPERATION,
    UPDATE_ASSET_PROPERTY_DEFINITION_OPERATION,
    SET_ASSET_PROPERTY_VALUE_OPERATION,
    DELETE_ASSET_PROPERTY_DEFINITION_OPERATION,
    DELETE_ASSET_PROPERTY_VALUE_OPERATION
} from 'app/store/__generated__/operations';
import {
    LOAD_ATTRIBUTE_DEFINITIONS,
    CREATE_ATTRIBUTE_DEFINITION,
    UPDATE_ATTRIBUTE_DEFINITION,
    DELETE_ATTRIBUTE_DEFINITION,
    SET_ATTRIBUTE_VALUE,
    DELETE_ATTRIBUTE_VALUE,
    OPEN_DIALOG,
    CLOSE_DIALOG
} from './types.js';

export const doLoadAttributeDefinitions = () => ({
    type: LOAD_ATTRIBUTE_DEFINITIONS,
    api: GET_ASSET_PROPERTY_DEFINITIONS_OPERATION
});

export const doCreateAttributeDefinition = ({ name, target, type, ...params }) => ({
    type: CREATE_ATTRIBUTE_DEFINITION,
    api: CREATE_ASSET_PROPERTY_DEFINITION_OPERATION,
    params: {
        name,
        target,
        payload: {
            _type: type,
            ...params
        }
    }
});

export const doUpdateAttributeDefinition = ({ uid, name, type, ...params }) => ({
    type: UPDATE_ATTRIBUTE_DEFINITION,
    api: UPDATE_ASSET_PROPERTY_DEFINITION_OPERATION,
    params: {
        uid,
        name,
        payload: {
            _type: type,
            ...params
        }
    }
});

export const doDeleteAttributeDefinition = ({ uid }) => ({
    type: DELETE_ATTRIBUTE_DEFINITION,
    api: DELETE_ASSET_PROPERTY_DEFINITION_OPERATION,
    params: { uid }
});

export const doSetAttributeValue = ({ uid, entityId, type, ...params }) => ({
    type: SET_ATTRIBUTE_VALUE,
    api: SET_ASSET_PROPERTY_VALUE_OPERATION,
    params: {
        definitionUid: uid,
        entityId,
        payload: {
            _type: type,
            ...params
        }
    }
});

export const doDeleteAttributeValue = ({ uid, entityId }) => ({
    type: DELETE_ATTRIBUTE_VALUE,
    api: DELETE_ASSET_PROPERTY_VALUE_OPERATION,
    params: {
        definitionUid: uid,
        entityId
    }
});

export const doOpenDialog = () => ({ type: OPEN_DIALOG });
export const doCloseDialog = () => ({ type: CLOSE_DIALOG });
